import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

   // The <link id="theme"> element was removed in audit commit 52f81670 because
   // the theme switcher plugin (jQuery.style.switcher.js) is not loaded —
   // the feature is dead. This service still exists because the layout
   // component injects it, so the querySelector now returns null.
   // All callers must guard against that.
   public linkTheme: HTMLLinkElement | null = document.querySelector('#theme');


  constructor() {

    const url = localStorage.getItem('theme') || './assets/css/colors/megna.css';
    this.linkTheme?.setAttribute('href', url);

  }



  changeTheme(theme: string) {


    const url = `./assets/css/colors/${theme}.css`;
    this.linkTheme?.setAttribute('href', url);
    localStorage.setItem('theme', url);

    this.checkCurrentTheme();


  }



  checkCurrentTheme() {

    const links = document.querySelectorAll('.selector');

    links.forEach( elemento => {

      elemento.classList.remove('working');
      const btnTheme = elemento.getAttribute('data-theme');
      const btnThemeUrl = `./assets/css/colors/${btnTheme}.css`;
      const currentTheme = this.linkTheme?.getAttribute('href');

      if ( btnThemeUrl === currentTheme) {

        elemento.classList.add('working');

      }

    });


  }




}
